import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { values } from 'ramda'

import TableNavigation from 'containers/Admin/TableNavigation/index'
import {
  ROW_OPTIONS,
} from './constants'

import styles from './styles.scss'

const StyledNavigation = CSSModules(styles, TableNavigation)

const UserTable = props => {
  return (
    <StyledNavigation
      {...props}
      pageOptions={values(ROW_OPTIONS)}
    />
  )
}

export default UserTable
